import "../../scss/pages/contact.scss";
import TomSelect from "tom-select/dist/js/tom-select.complete.min";
import Form from "../../js/components/form.js";
import ValidationInput from "../helpers/validationInput";

document.addEventListener("DOMContentLoaded", function () {
	
	const formModule = new Form();
	
	formModule.validationForm('#contactForm');
	
	new TomSelect("#formControlSelect", {
		create: false,
		allowEmptyOption: true,
		maxOptions: null,
		hideSelected: true,
		controlInput: null,
		render: {
			item: function (item, escape) {
				return '<div>' +
					'<span class="name style-selected-item">' + escape(item.text) + '</span>' +
					'</div>';
			},
			option: function (item, escape) {
				return '<div>' +
					'<span class="name style-selected-option">' + escape(item.text) + '</span>' +
					'</div>';
			}
		},
		onBlur: function () {
			const form = document.querySelector("#contactForm");
			const inputSelect = document.querySelector('#formControlSelect');
			ValidationInput.validateInput(inputSelect, form.id);
		}
	});
	
	formModule.submitForm('#contactForm', 'contact/submit-contact-form', '#loaderContactForm', 'contact', null, true, true, false, true);
	
});